import env from '@beam-australia/react-env'

export interface Envs {
  apiUrl: string
  wsUrl: string
  backendAppClientId: string
  frontendAppClientId: string
  tenantId: string
  backendAppVersion: string
  apiBasicAuthType: boolean
  apiBasicAuthTypeUsername: string
  apiBasicAuthTypePassword: string
  bypassLogin: boolean
  env: string
  showEnvBadge: boolean
  productModes: {
    anomaly: string
    classification: string
    segmentation: string
    patch: string
  }
}

export const getEnvs = (): Envs => ({
  apiUrl: env('API_URL'),
  wsUrl: env('WS_URL'),
  backendAppClientId: env('BACKEND_APP_CLIENT_ID'),
  frontendAppClientId: env('FRONTEND_APP_CLIENT_ID'),
  tenantId: env('TENANT_ID'),
  backendAppVersion: env('BACKEND_APP_VERSION'),
  apiBasicAuthType: env('API_BASIC_AUTH_TYPE') === 'true',
  apiBasicAuthTypeUsername: env('API_BASIC_AUTH_USERNAME'),
  apiBasicAuthTypePassword: env('API_BASIC_AUTH_PASSWORD'),
  bypassLogin: env('BYPASS_LOGIN') === 'true',
  env: env('ENV'),
  showEnvBadge: env('SHOW_ENV_BADGE') === 'true',
  productModes: {
    anomaly: env('PRODUCT_ANOMALY_MODE'),
    classification: env('PRODUCT_CLASSIFICATION_MODE'),
    segmentation: env('PRODUCT_SEGMENTATION_MODE'),
    patch: env('PRODUCT_PATCH_MODE'),
  },
})
